import React from 'react';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-24 px-4" data-id="element-190">
      <div className="max-w-4xl mx-auto bg-surface/50 border border-zinc-800 rounded-3xl p-8 md:p-16 text-center relative overflow-hidden" data-id="element-191">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[400px] bg-primary/5 blur-[100px] rounded-full pointer-events-none" data-id="element-192" />

        <div className="relative z-10" data-id="element-193">
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-primary/10 border-2 border-primary mb-8 shadow-[0_0_40px_rgba(249,168,212,0.3)]" data-id="element-194">
            <Shield className="w-12 h-12 text-primary" data-id="element-195" />
          </div>

          <h2 className="text-3xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-196">
            PROBALO DURANTE <span className="text-primary" data-id="element-197">7 DÍAS</span>
          </h2>

          <p className="text-lg md:text-2xl text-zinc-300 leading-relaxed max-w-2xl mx-auto font-medium" data-id="element-198">
            Descargá los tomos. Revisá las clases. Aplicalas con tu grupo. Si
            sentís que este sistema no te ahorra horas de planificación, mandás
            un mail y te devolvemos el 100% de tu dinero.
          </p>

          <p className="mt-8 text-primary font-bold text-lg" data-id="element-199">
            Sin preguntas. Sin formularios.
          </p>
        </div>
      </div>
    </section>;
}